module.exports = __webpack_public_path__ + "img/45-image-1-1@2x.124e8903.png";